import React from 'react';
import MultiModelPoseWorkflowBase, { MultiModelPoseWorkflowConfig } from './MultiModelPoseWorkflowBase';

const STITCHED_CLOTHS_CONFIG: MultiModelPoseWorkflowConfig = {
  workflowType: 'stitched-cloths',
  workflowName: 'Stitched Cloths',
  backImageRequired: false,
  backImageLabel: 'Back Image (Optional)',
  downloadFilenamePrefix: 'stitched',
};

interface StitchedClothsWorkflowProps {
  onBackToWorkflows: () => void;
  initialInputImages?: string[];
  initialGeneratedImages?: string[];
  initialModelImageUrl?: string;
  initialBackgroundImageUrl?: string;
}

const StitchedClothsWorkflow: React.FC<StitchedClothsWorkflowProps> = ({ onBackToWorkflows, initialInputImages, initialGeneratedImages, initialModelImageUrl, initialBackgroundImageUrl }) => (
  <MultiModelPoseWorkflowBase
    onBackToWorkflows={onBackToWorkflows}
    initialInputImages={initialInputImages}
    initialGeneratedImages={initialGeneratedImages}
    initialModelImageUrl={initialModelImageUrl}
    initialBackgroundImageUrl={initialBackgroundImageUrl}
    config={STITCHED_CLOTHS_CONFIG}
  />
);

export default StitchedClothsWorkflow;
